const callusMessage = (loggedOutMessage, loggedInMessage) => (document.body.getAttribute('isloggedin') ? loggedInMessage : loggedOutMessage);

export default callusMessage;
